import React from 'react';
import { Field } from 'redux-form';
import RadioButton from 'components/atoms/form/RadioButton';
import FormSectionHeading from 'components/atoms/form/FormSectionHeading';

const normalizeBoolean = (value) => {
    if (value === 'true') {
        return true;
    }

    if (value === 'false') {
        return false;
    }

    return value;
};

const DemoMode = () => (
    <React.Fragment>
        <FormSectionHeading>Demo Mode</FormSectionHeading>
        <Field component={RadioButton} label="Yes" type="radio"
            value={true} name='isDemo' normalize={normalizeBoolean}>
        </Field>
        <br />
        <Field component={RadioButton} label="No" type="radio"
            value={false} name='isDemo' normalize={normalizeBoolean}>
        </Field>
    </React.Fragment>
);

export default DemoMode;



// WEBPACK FOOTER //
// ./src/components/organisms/entity/edit/DemoMode.js